import dynamic from "next/dynamic";
import React, { FC } from "react";
import { IPaymentPlan } from "./IPaymentPlan";
import { useHidePaymentPlan } from "./hooks/useHidePaymentPlan";

const PaymentPlan = dynamic(() => import("./PaymentPlan"));

const LazyLoadedPaymentPlan: FC<IPaymentPlan.IProps> = props => {
    const hideComponent = useHidePaymentPlan(props);
    if (hideComponent) return null;

    return <PaymentPlan {...props} />;
};

export default LazyLoadedPaymentPlan;
